import React from "react";
import TopMenu from "../../components/TopMenu/TopMenu";
import { useTranslation } from 'react-i18next'
import Table, { TableColumn } from "../../components/Table/Table";
import useEntrevistadores from "./useEntrevistadores";
import "./ListaEntrevistadores.css";

type EntrevistadorRow = {
  id: string;
  curso: string;
  name: string;
  funcao: string;
  online: boolean;
  presencial: boolean;
  place: string;
  email: string;
  telefone: string;
};

export default function ListaEntrevistadores() {
  const { entrevistadores } = useEntrevistadores();
  const { t } = useTranslation();

  const columns: TableColumn<EntrevistadorRow>[] = [
    {
      id: "curso",
      header: t("pages.listaEntrevistadores.curso"),
      render: (entrevistador) => entrevistador.curso
    },
    {
      id: "name",
      header: t("pages.listaEntrevistadores.nome"),
      render: (entrevistador) => entrevistador.name
    },
    {
      id: "funcao",
      header: t("pages.listaEntrevistadores.funcao"),
      render: (entrevistador) => entrevistador.funcao
    },
    {
      id: "online",
      header: t("pages.listaEntrevistadores.online"),
      render: (entrevistador) => (entrevistador.online ? t("pages.listaEntrevistadores.sim") : t("pages.listaEntrevistadores.nao"))
    },
    {
      id: "presencial",
      header: t("pages.listaEntrevistadores.presencial"),
      render: (entrevistador) => (entrevistador.presencial ? t("pages.listaEntrevistadores.sim") : t("pages.listaEntrevistadores.nao"))
    },
    {
      id: "place",
      header: t("pages.listaEntrevistadores.cidade"),
      render: (entrevistador) => entrevistador.place
    },
    {
      id: "email",
      header: t("pages.listaEntrevistadores.email"),
      render: (entrevistador) => entrevistador.email
    },
    {
      id: "telefone",
      header: t("pages.listaEntrevistadores.telefone"),
      render: (entrevistador) => entrevistador.telefone
    }
  ];

  return (
    <div className="lista-entrevistadores-page">
      <TopMenu />

      <main className="lista-entrevistadores-content">
        <section className="lista-entrevistadores-hero">
          <p className="lista-entrevistadores-hero-title">{t("pages.listaEntrevistadores.title")}</p>
          <p className="lista-entrevistadores-hero-subtitle">
            {t("pages.listaEntrevistadores.subtitle")}
          </p>
        </section>

        <Table<EntrevistadorRow>
          beforeHeader={
            <div className="lista-entrevistadores-topbar">{t("pages.listaEntrevistadores.entrevistadores")}</div>
          }
          bodyRowClassName="lista-entrevistadores-row"
          columns={columns}
          data={entrevistadores}
          getRowKey={(entrevistador) => entrevistador.id}
          gridTemplateColumns="minmax(90px, 0.8fr) minmax(180px, 1.5fr) minmax(150px, 1.3fr) minmax(90px, 0.9fr) minmax(110px, 1fr) minmax(140px, 1.2fr) minmax(180px, 1.5fr) minmax(140px, 1.3fr)"
          headerRowClassName="lista-entrevistadores-row lista-entrevistadores-header"
          stickyHeaderTop={44}
          wrapperClassName="lista-entrevistadores-table"
        />
      </main>
    </div>
  );
}

